import React from 'react'
import type { AuthUser } from '@lura/shared'

export interface AuthContextType {
  user: AuthUser | null
  loading: boolean
  signIn: (email: string, password: string) => Promise<void>
  signUp: (data: {
    email: string
    password: string
    first_name?: string
    last_name?: string
  }) => Promise<void>
  signOut: () => Promise<void>
  resendConfirmation: (email: string) => Promise<void>
  resetPassword: (email: string) => Promise<void>
  refreshUser: () => Promise<void>
  canAccessApp: boolean
}

export const AuthContext = React.createContext<AuthContextType | undefined>(
  undefined
)
